import { DOMOutputSpecArray, MarkSpec } from 'prosemirror-model';

import { RtSchemaType } from '../../../editor/types';
import { MarkName } from '../../../schema/marks';

export class StrikethroughMark implements MarkSpec {
  public static readonly markName = MarkName.Strikethrough;
  public parseDOM = [
    { tag: 's' },
    { tag: 'strikethrough' },
    { style: 'text-decoration=line-through' },
  ];
  public toDOM(): DOMOutputSpecArray {
    return ['s', 0];
  }
}

export type StrikethroughSchema = RtSchemaType<any, typeof StrikethroughMark>;
